import { getUserInternalAccessToken } from "@/api/access-token-backoffice";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { apiBackofficeT2b } from "@/lib/axios";
import { IFilter } from "@/types/filter.types";
import { RequestPagination } from "@/types/requests.types";

export interface SalesProductPrice {
  id: number;
  salesProductId: number;
  price: number;
  currency: string;
  isActive: boolean;
  validFrom: string;
  validTo?: string;
  discountPercentage?: number;
  promotionalPrice?: number;
  createdAt: string;
  updatedAt: string;
  salesProduct?: {
    id: number;
    name: string;
    description?: string;
  };
}

export interface GetAllSalesProductPricesResponse {
  items: SalesProductPrice[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export async function getAllSalesProductPrices(
  pagination: RequestPagination,
  filter?: IFilter<SalesProductPrice>[]
): Promise<GetAllSalesProductPricesResponse> {
  try {
    const { accessToken } = await getUserInternalAccessToken();
    const paginationQuery = buildPaginationQuery(pagination);
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    const body = { filter: filter || [] };
    const response = await apiBackofficeT2b.post(
      `/v1/salesproductprice/filter?${paginationQuery}`,
      body,
      config
    );

    return response.data as GetAllSalesProductPricesResponse;
  } catch (error) {
    console.error("Error in getAllSalesProductPrices:", error);
    throw error;
  }
}
